import { LIST_PERMISSIONS, LOADING_PERMISSIONS } from "../../constants/types";
import { IPermissions } from "../../types/user/permissions/ipermissions/ipermissions.interface";

export interface IPermissionsState {
  permissions: PermissionsState;
}

export interface PermissionsState {
  loading: boolean;
  count: number;
  next: number | null;
  previous: number | null;
  permissions: IPermissions | null;
}
const initialState: PermissionsState = {
  loading: false,
  count: 0,
  next: null,
  previous: null,
  permissions: null,
};

const permissionsReducer = (state = initialState, action: any) => {
  const { permissions } = action.payload || {};
  switch (action.type) {
    case LOADING_PERMISSIONS:
      return {
        ...state,
        loading: true,
      };
    case LIST_PERMISSIONS:
      return {
        ...state,
        loading: false,
        permissions,
      };

    default:
      return state;
  }
};

export default permissionsReducer;
